import * as actions from './Actions.js';

import { Col, Row } from 'react-bootstrap';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';

import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import FilterButtons from '../components/FilterButtons.react';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import Link from 'portaltransparencia-common/components/link/Link.react.js';
import { Map } from 'immutable';
import NotasExplicativas from '../notaexplicativa/Form.react';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import PageHeader from '../components/PageHeader.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import UltimaAtualizacao from '../ultimaatualizacao/Form.react.js';
import { addPagination } from 'portaltransparencia-common/libs/AddFilter';
import configuration from 'portaltransparencia-common/config/Config.js';
import { connect } from 'react-redux';

export class Obra extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    situacoes: PropTypes.object.isRequired,
    loadSituacoes: PropTypes.func.isRequired,
    searchObras: PropTypes.func.isRequired,
    filtros: PropTypes.object,
    onChange: PropTypes.func,
    location: PropTypes.object.isRequired,
    resetCrud: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { loadSituacoes, page } = this.props;

    loadSituacoes().then(this.searchWithPage(page));
  }

  searchWithPage = page => {
    const { searchObras } = this.props;

    const filter = this.montaFilter(page);

    searchObras(filter);
  };

  onChangeFiltro = event => {
    const { onChange } = this.props;

    onChange('filtroObras', event);
  };

  onResetFiltro = () => {
    const { resetCrud, searchObras } = this.props;
    resetCrud('filtroObras');
    searchObras('');
  };

  onShowContrato = data => {
    this.showContrato(data);
  };

  showContrato = data => {
    const entidade = data.get('entidade');
    const idContrato = data.get('idContrato');
    const exercicioContrato = data.get('exercicioContrato');

    this.props.history.push(
      `/contratos/obra?entidade=${entidade}&exercicio=${exercicioContrato}&contrato=${idContrato}`
    );
  };

  addFilter = function (actualFilter, filterAnd) {
    let filterOperator = '';
    if (actualFilter !== '') {
      filterOperator = '&';
    }
    return actualFilter + filterOperator + filterAnd;
  };

  montaFilter = function (page) {
    const { filtros } = this.props;
    const { entidade, exercicio } = StorageService.getItem('userInfo');

    let filter = `entidade=${entidade.id}&exercicio=${exercicio.id}`;

    if (filtros.get('descricaoBem')) {
      filter = this.addFilter(
        filter,
        `descricaoBem=${filtros.get('descricaoBem')}`
      );
    }
    if (filtros.get('descricaoObra')) {
      filter = this.addFilter(
        filter,
        `descricaoObra=${filtros.get('descricaoObra')}`
      );
    }
    if (filtros.get('situacao')) {
      filter = this.addFilter(filter, `situacao=${filtros.get('situacao')}`);
    }
    if (filtros.get('empresa')) {
      filter = this.addFilter(filter, `empresa=${filtros.get('empresa')}`);
    }

    return addPagination(page, filter);
  };

  onExporta = (exportType, openTab, windowParams) => {
    const { apiURL } = configuration;

    let filtro = this.montaFilter() + '&exportType=' + exportType;

    window.open(`${apiURL}/api/obras/report?${filtro}`, openTab, windowParams);
  };

  renderObras = obra => {
    return (
      <TableActions
        ref="row"
        key={obra.get('idOrdemServico') + '_' + obra.get('exercicio')}
        data={obra}
        onMore={this.onViewDetalhes}
      >
        <td>{obra.get('ordemServico') + '/' + obra.get('exercicio')}</td>
        <td>{obra.get('descricaoBem')}</td>
        <td>{obra.get('descricao')}</td>
        <td>{obra.get('empresa')}</td>
        <td>{DateUtils.formatDateTimeShort(obra.get('data'))}</td>
        <td>{DateUtils.formatDateTimeShort(obra.get('previsaoTermino'))}</td>
        <td className="right">
          <NumberFormatter value={obra.get('valorIntervencao')} />
        </td>

        {!!obra.get('valorContrato') && obra.get('valorContrato') > 0 && (
          <td className="right">
            <Link
              onClick={this.showContrato}
              data={obra}
              value={NumberUtils.format(obra.get('valorContrato'))}
              icon="fa fa-external-link-square"
              iconPosition="right"
            />
          </td>
        )}
        {(!obra.get('valorContrato') || obra.get('valorContrato') <= 0) && (
          <td className="right">
            <NumberFormatter value={obra.get('valorContrato')} />
          </td>
        )}

        <td className="right">
          <NumberFormatter value={obra.get('valorAditivo')} />
        </td>
        <td>{obra.get('situacao')}</td>
        <td className="right">{NumberUtils.format(obra.get('percentual'))}%</td>
      </TableActions>
    );
  };

  renderSituacao = item => {
    return (
      <option key={item.get('id')} value={item.get('id')}>
        {item.get('descricao')}
      </option>
    );
  };

  onViewDetalhes = item => {
    const entidade = item.get('entidade');
    const exercicio = item.get('exercicio');
    const idOrdemServico = item.get('idOrdemServico');

    this.props.history.push(
      `/obraspublicas/detalhes?entidade=${entidade}&exercicioObra=${exercicio}&idOrdemServico=${idOrdemServico}`
    );
  };

  onConsulta = event => {
    const { page } = this.props;
    const initialPage = page.set('number', 0);

    this.searchWithPage(initialPage);

    event && event.preventDefault();
    this.refs.panelFiltroObras && this.refs.panelFiltroObras.collapse();
  };

  render() {
    const { page, situacoes, filtros } = this.props;

    if (!page.has('content')) {
      return null;
    }

    return (
      <section>
        <PageHeader location={this.props.location} />

        <Panel
          title="Consultar em Obras Públicas"
          isForm
          mobileClose
          ref="panelFiltroObras"
        >
          <form>
            <Row>
              <Col xs={12} sm={6} md={3}>
                <div className={'form-group'}>
                  <label className="label">Situação</label>
                  <select
                    name="situacao"
                    key={filtros.get('situacao')}
                    className="form-control control-label"
                    ref="situacao"
                    type="select"
                    onChange={this.onChangeFiltro}
                    value={filtros.get('situacao')}
                  >
                    <option value=""> Selecione </option>
                    {situacoes.map(this.renderSituacao)}
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Input
                  name="descricaoBem"
                  ref="descricaoBem"
                  label="Descrição do Bem"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('descricaoBem')}
                />
              </Col>
              <Col xs={12} sm={6} md={5}>
                <Input
                  name="descricaoObra"
                  ref="descricaoObra"
                  label="Descrição da Intervenção"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('descricaoObra')}
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Input
                  name="empresa"
                  ref="empresa"
                  label="Empresa"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('empresa')}
                />
              </Col>
              <Col xs={12} sm={6} md={3}>
                <FilterButtons
                  onConsulta={this.onConsulta}
                  onReset={this.onResetFiltro}
                />
              </Col>
            </Row>
          </form>
        </Panel>

        <NotasExplicativas pathname={this.props.location.pathname} />

        <Panel expansible={false} isForm tableResponsive>
          <Row>
            <Col xs={6}>
              <UltimaAtualizacao modulo="25" />
            </Col>
            <Col xs={6}>
              <ExportButtonGroup
                onClick={this.onExporta}
                visible={page.get('content').size > 0}
              />
            </Col>
          </Row>

          <div className="panel-table-outer">
            <table className="panel-table striped fancy">
              <TableHeader empty={page.get('content').isEmpty()}>
                <tr>
                  <TableHeaderItem
                    field="ordemServico"
                    label="O.S/Ano"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="descricaoBem"
                    label="Bem(Imóvel)"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="descricao"
                    label="Descrição da Intervenção"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="empresa"
                    label="Empresa"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="data"
                    label="Data Início"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="previsaoTermino"
                    label="Previsão Término"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="valorIntervencao"
                    label="Valor Intervenção"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="valorContrato"
                    label="Valor Contrato"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="valorAditivo"
                    label="Valor Aditivo"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="situacao"
                    label="Situação"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="percentual"
                    label="Medições"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <th></th>
                </tr>
              </TableHeader>
              <tbody>{page.get('content').map(this.renderObras)}</tbody>
            </table>
          </div>
        </Panel>

        <SearchPagination page={page} searchWithPage={this.searchWithPage} />
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    page: state.obra.get('obras'),
    situacoes: state.obra.get('situacoes'),
    filtros: state.crud.getIn(['filtroObras', 'currentRecord'], Map({}))
  };
}

const allActions = {
  ...actions,
  onChange,
  resetCrud
};

export default connect(mapStateToProps, allActions)(Obra);
